export default __webpack_public_path__ + "static/0220-402335602a11051dd97cf2a9077c828e.png";